import { getAppTypeForWeb } from "../../utils/helpers";
import { TRACKING_ACTIONS } from "../constants";

export const getHyperpureImpressionParams = (data, outletId, warehouseCode) => ({
    component_id: data?.ComponentId,
    component_name: data?.ComponentName,
    component_type: data?.ComponentType,
    master_tracking_id: data?.MasterTrackingId,
    metadata: data?.Metadata,
    parent_tracking_id: data?.ParentTrackingId,
    tracking_id: data?.TrackingId,
    action: TRACKING_ACTIONS.ACTION_TYPE_IMPRESSION,
    outlet_id: outletId,
    warehouse_code: warehouseCode,
    app_type: getAppTypeForWeb(),
});
